import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["item", "buttonContainer"]
    static values = {
        limit: { type: Number, default: 6 },
        increment: { type: Number, default: 6 }
    }

    connect() {
        this.visibleCount = this.limitValue
        this.updateVisibility()
    }

    showMore(event) {
        if (event) event.preventDefault()
        this.visibleCount += this.incrementValue
        this.updateVisibility()
    }

    updateVisibility() {
        this.itemTargets.forEach((item, index) => {
            if (index < this.visibleCount) {
                item.classList.remove("hidden")
            } else {
                item.classList.add("hidden")
            }
        })

        // The button container is only rendered when there are more items than
        // the initial limit, so it may be absent for short lists.
        if (!this.hasButtonContainerTarget) return

        // Hide button if all items are visible
        if (this.visibleCount >= this.itemTargets.length) {
            this.buttonContainerTarget.classList.add("hidden")
        } else {
            this.buttonContainerTarget.classList.remove("hidden")
        }
    }
}
